import platform from 'platform'

import { TweenLite } from 'gsap/TweenLite'
import { Power3 } from 'gsap/EasePack'

import CoreResize from '../../mixins/core-resize'
import CoreScroll from '../../mixins/core-scroll'
import CoreRAF from '../../mixins/core-raf'
import AppPage from '../../mixins/app-page'

import Background from './Background'
import AppHsm from '../app-hsm'
import AppPartners from '../app-partners'
import AppBtnSkew from '../app-btn-skew'
import AppHsmLink from '../app-hsm-link'
import AppParallax from '../app-parallax'
import AppBtn from '../app-btn'
import AppCarousel3d from '../app-carousel-3d'

// URL list
import URL from '../../../config.url'

export default
{
    name: 'page-home',

    mixins:
    [
        AppPage,
        CoreResize,
        CoreScroll,
        CoreRAF
    ],

    components:
    {
        AppHsm,
        AppPartners,
        AppBtnSkew,
        AppHsmLink,
        AppParallax,
        AppBtn,
        AppCarousel3d
    },

    data()
    {
        return {
            state: -1,
            links: null,
            nav: this.contentPage.nav,
            carousel: this.contentPage.carousel,
            isMenuVisible: true,
            url: URL,
            mousePos: [0, 0],
            mousePosSmooth: [0, 0],

            isFakeScroll: true,

            scrollY: 0
        }
    },

    computed:
    {
        games()
        {
            const games = []
            const ga = Object.keys(this.nav.games)
            const go = this.nav.games

            for (let i = 0, l = ga.length; i < l; i += 1)
            {
                const game = go[ga[i]]

                if (game.button_up.label === 'Teams')
                {
                    game.button_up.url = this.$root.getPageURLFromID('teams')
                }

                if (game.button_down.label === 'Matches')
                {
                    game.button_down.url = this.$root.getPageURLFromID('esMatchDetails').replace(':slug', game.informations.slug)
                }

                games.push(game)
            }

            return games
        }
    },

    created()
    {
        this.isFakeScroll = this.$root.isFakeScroll
        this.isMobile = ['Android', 'iOS', 'Windows Phone'].indexOf(platform.os.family) !== -1
    },

    mounted()
    {
        this._csgoBg = this.$el.querySelector('.js-bg-csgo')
        this._sfvBg = this.$el.querySelector('.js-bg-sfv')
        this._rlBg = this.$el.querySelector('.js-bg-rl')

        this._csgoTitle = this.$el.querySelector('.js-bg-csgo')
        this._sfvTitle = this.$el.querySelector('.js-bg-sfv')
        this._rlTitle = this.$el.querySelector('.js-bg-rl')

        this.eventHub.$emit('bg-change')
        this.setBackground()

        window.addEventListener('mousemove', this._mouseMove)

        this.onScroll(0)
    },

    destroyed()
    {
        window.removeEventListener('mousemove', this._mouseMove)
    },

    methods:
    {
        _onCarousel3DIndexChange(index)
        {
            if (this._bg3d)
            {
                TweenLite.to(this._bg3d.globeMover.position, 1, { z: -index * 0.02, ease: Power3.easeInOut })
            }
        },

        _onPartnersLoaded()
        {
            this.$emit('load', this)
        },

        onScroll(y)
        {
            const winH = this.resize.height
            const preciseState = y / winH - 1

            this._preciseState = preciseState
            this.isMenuVisible = preciseState < 2.25 && (this.resize.height > 1024 || preciseState > -0.25)
            this.state = Math.round(preciseState)

            this._setYPosHsm(y)

            this.scrollY = y

            if (this.isFakeScroll)
            {
                this._bgContainerEl.style.transform = 'translateY(' + this.scrollY + 'px) translateZ(-1000px)'
            }
        },

        onResized(w, h)
        {
            this.isMenuVisible = this._preciseState < 2.25 && (this.resize.height > 1024 || this._preciseState > -0.25)

            if (this._bg3d)
            {
                this._bg3d.resize(this._bgContainerEl.offsetWidth, this._bgContainerEl.offsetHeight)
            }
        },

        onFrame(delta, time)
        {
            // 3D background
            if (this._bg3d)
            {
                if (this.isFakeScroll)
                {
                    this.mousePosSmooth[0] += (this.mousePos[0] - this.mousePosSmooth[0]) * 0.02
                    this.mousePosSmooth[1] += (this.mousePos[1] - this.mousePosSmooth[1]) * 0.02

                    this._bg3d.cameraContainer.position.z = this.mousePosSmooth[0]
                    this._bg3d.cameraContainer.position.y = -this.mousePosSmooth[1]

                    this._bg3d.scrollPos = this.$root.getScrollY() / this.resize.height

                    this._bg3d.update()
                }
                else if (this._preciseState < 0)
                {
                    this.mousePosSmooth[0] += (this.mousePos[0] - this.mousePosSmooth[0]) * 0.02
                    this.mousePosSmooth[1] += (this.mousePos[1] - this.mousePosSmooth[1]) * 0.02

                    this._bg3d.cameraContainer.position.z = this.mousePosSmooth[0]
                    this._bg3d.cameraContainer.position.y = -this.mousePosSmooth[1]

                    // this._bg3d.scrollPos = this.$root.getScrollY() / this.resize.height

                    this._bg3d.update()
                }
            }
        },


        // ---------------------------
        //
        //      INTERACTIONS

        _onOverGame(num)
        {
            clearTimeout(this._moveBGTo)
            this._moveBGTo = setTimeout(() =>
            {
                this.$root.scrollTo((num + 1) * this.resize.height, true)
            }, 300)
            // this.$root.scrollTo((num + 1) * this.resize.height, true)
        },

        _onOutGames()
        {
            clearTimeout(this._moveBGTo)
        },

        _mouseMove(event)
        {
            if (this._bg3d)
            {
                const x = (event.clientX / this.resize.width - 0.5) * 0.05
                const y = (event.clientY / this.resize.height - 0.5) * 0.05

                this.mousePos[0] = x
                this.mousePos[1] = y

                this._bg3d.setMouse(event.clientX / this.resize.width - 0.5, event.clientY / this.resize.height - 0.5)
            }
        },


        // ---------------------------
        //
        //      PARALLAX SCROLLING

        _setYPosHsm(y)
        {
            // Disable parralax on background
            // Avoid low perfs
            if (false)
            {
                if (!this._csgoBg || !this._sfvBg || !this._rlBg)
                {
                    return false
                }

                const winH = this.resize.height
                const parCSGO = this._getParralaxRule(y, 1, winH, 0.05)
                const parSFV = this._getParralaxRule(y, 2, winH, -0.05)
                const parRocket = this._getParralaxRule(y, 3, winH, 0.05)

                if (this._preciseState > -1 && this._preciseState < 1)
                {
                    this._csgoBg.style.transform = parCSGO
                }

                if (this._preciseState > 0 && this._preciseState < 2)
                {
                    this._sfvBg.style.transform = parSFV
                }

                if (this._preciseState > 1 && this._preciseState < 3)
                {
                    this._rlBg.style.transform = parRocket
                }
            }

            // Disable parralax on titles
            // Avoid low perfs
            else if (false)
            {
                if (!this._csgoTitle || !this._sfvTitle || !this._rlTitle)
                {
                    return false
                }

                const winH = this.resize.height
                const parCSGO = this._getParralaxRule(y, 1, winH, -0.05)
                const parSFV = this._getParralaxRule(y, 2, winH, 0.05)
                const parRocket = this._getParralaxRule(y, 3, winH, -0.05)

                if (this._preciseState > -1 && this._preciseState < 1)
                {
                    this._csgoTitle.style.transform = parCSGO
                }

                if (this._preciseState > 0 && this._preciseState < 2)
                {
                    this._sfvTitle.style.transform = parSFV
                }

                if (this._preciseState > 1 && this._preciseState < 3)
                {
                    this._rlTitle.style.transform = parRocket
                }
            }
        },

        _getParralaxRule(scrollY, boxNum, windowH, power)
        {
            const v = (scrollY - boxNum * windowH) * power
            return 'translateX(-50%) translateY(-50%) rotate(4deg) translateY(' + v.toFixed(1) + 'px) translateZ(0)'
        },


        // ---------------------------
        //
        //      BACKGROUND 3D

        setBackground()
        {
            const countriesOptions = {
                uk:
                {
                    POICoordinates: [51, -0.301776],
                    globeRotation: [0, 0, 0],
                    cameraPosition: [-1, 0.775, 0],
                    mapMaskImage: require('./Background/images/map-mask-uk.jpg')
                },
                au:
                {
                    POICoordinates: [-33.716398, 150.448055],
                    globeRotation: [3.94, 5.92, 4.33],
                    cameraPosition: [-1.3, 1.475, 0],
                    mapMaskImage: require('./Background/images/map-mask-au.jpg')
                }
            }
            let countryOptions = countriesOptions[this.contentGlobal.country]

            if (!countryOptions)
            {
                countryOptions = countriesOptions.uk
            }

            const sections = []

            for (const _videoGame of this.contentGlobal.videoGames)
            {
                sections.push({
                    image: _videoGame.cover
                })
            }

            this._bgContainerEl = this.$el.querySelector('.js-background')

            const background = new Background({
                $container: this._bgContainerEl,
                isMobile: this.isMobile,
                autoResize: false,
                autoRAF: false,
                POICoordinates: [countryOptions.POICoordinates],
                globeRotation: countryOptions.globeRotation,
                cameraPosition: countryOptions.cameraPosition,
                mapMaskImage: countryOptions.mapMaskImage,
                filters: [], // ['blur']
                cameraDebug: false,
                sections
            })

            this._bg3d = background
            this.mousePos[0] = 0
            this.mousePos[1] = 0
            this.mousePosSmooth[0] = 0
            this.mousePosSmooth[1] = 0

            this.onResized(this._bgContainerEl.offsetWidth, this._bgContainerEl.offsetHeight)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/script.js